// extracted by mini-css-extract-plugin
export default {"disabled":"xwYpQYJzO2EehuNrAFf4"};